export class DonationConfig {
  attestationThresholdAmount: number = 0;
  attestationHeader: string = '';
  attestationFooter: string = '';
  attestationPrefix: string = '';
  // Belcotax-on-web export of the 281.71 fiches (Belgium)
  belcotaxEnabled: boolean = false;
  belcotaxContactFirstname: string = '';
  belcotaxContactLastname: string = '';
  belcotaxContactEmail: string = '';
  belcotaxContactPhone: string = '';
}
